import SystemDrawerNavigationItem from "../../items/SystemDrawerNavigationItem";
import {
    kSystemDrawerAboutNavigationItems,
    kSystemDrawerLegalsNavigationItems,
    kSystemDrawerMainNavigationItems
} from "../../../constants/navigation";
import SystemCustomDivider from "../../dividers/SystemCustomDivider";
import {useLocation} from "react-router-dom";

export default function HomeDrawerMainNavigation() {
    // Used in SystemAppDrawer to display main navigation items

    // PROPERTIES
    const location = useLocation();
    const currentPath = location.pathname;

    // BUILD
    return (
        <div className={"bg-backgroundLight3 overflow-auto grow w-full flex flex-col"}>
            {kSystemDrawerMainNavigationItems.map((item, index) => (
                <SystemDrawerNavigationItem key={index}
                                            item={item}
                                            isActive={currentPath === item.route} />
            ))}
            <SystemCustomDivider color={'bg-greyLight3'} />
            {kSystemDrawerAboutNavigationItems.map((item, index) => (
                <SystemDrawerNavigationItem key={index}
                                            item={item}
                                            isActive={currentPath === item.route} />
            ))}
            <SystemCustomDivider color={'bg-greyLight3'} />
                                 {/*extraClass={'mt-[8px] mb-[6px]'} />*/}
            {kSystemDrawerLegalsNavigationItems.map((item, index) => (
                <SystemDrawerNavigationItem key={index}
                                            item={item}
                                            isActive={currentPath === item.route} />
            ))}
        </div>
    );
}